import styled from "styled-components";

export const CheckerNotificationWrapper = styled.div`
  width: 100%;
  height: 100%;

  .checkerWarningMsg {
    .ant-result-title {
      font-weight: 600;
    }

    .ant-result-extra {
      margin: 0;

      p span {
        color: var(--accent);
        font-weight: 600;
      }
    }
  }
`;
